import * as React from 'react';
import { isEqual } from 'vet-bones/utils';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useUpdateLabel = (iri?: string) => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();

  const labelsByIri = useReduxSelector(
    projectLabelsByIriSelector(projectId),
    isEqual
  );

  return React.useCallback(
    (newLabel: string) => {
      if (!diagram || !iri) {
        return;
      }
      const oldLabel = labelsByIri[iri];
      if (newLabel === oldLabel) {
        return;
      }

      commitDiagramModel(diagram, setLabelForIri(iri, newLabel));
    },
    [diagram, iri, labelsByIri]
  );
};
